/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Filter_DraftInputs */

const cs_signing_filter_draft = /** @type {(inputs: Signing_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koncept`)
};

const en_signing_filter_draft = /** @type {(inputs: Signing_Filter_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Signing_Filter_DraftInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_filter_draft = /** @type {((inputs?: Signing_Filter_DraftInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Filter_DraftInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_filter_draft(inputs)
	return cs_signing_filter_draft(inputs)
});